import en from '@/src/translations/en.json';
import ja from '@/src/translations/ja.json';
import ko from '@/src/translations/ko.json';
import zh from '@/src/translations/zh.json';
import React from 'react';
import { CircleFlag } from 'react-circle-flags';
import { Language } from '../models';

export type TranslationKey =
  | '24hChange'
  | '24hVolume'
  | 'action'
  | 'amount'
  | 'buy'
  | 'connect'
  | 'connectWalletFirst'
  | 'connectionError'
  | 'connectionLost'
  | 'connectionTimeout'
  | 'currentNetwork'
  | 'destinationAddress'
  | 'destinationTag'
  | 'disconnect'
  | 'domain'
  | 'domainSet'
  | 'domainDelete'
  | 'credentialCreate'
  | 'credentialAccept'
  | 'credentialDelete'
  | 'language'
  | 'limitPrice'
  | 'markets'
  | 'network'
  | 'noOrders'
  | 'openOrders'
  | 'orderBook'
  | 'orderId'
  | 'offerSequence'
  | 'pair'
  | 'wallet'
  | 'price'
  | 'qty'
  | 'quantity'
  | 'retry'
  | 'selectNetwork'
  | 'selectNetworkFirst'
  | 'selectWallet'
  | 'sell'
  | 'sendRequest'
  | 'side'
  | 'swap'
  | 'theme'
  | 'title'
  | 'total'
  | 'totalPrice'
  | 'trading'
  | 'warning'
  | 'warningTitle'
  | 'xrplAccount'
  | 'yourAccounts'
  | 'yourBalances'
  | 'history'
  | 'previous'
  | 'next'
  | 'walletAddress'
  | 'oracles';

export const translations = {
  en,
  zh,
  ja,
  ko,
} as const;

export const languageOptions = [
  {
    value: 'en',
    label: 'English',
    icon: React.createElement(CircleFlag, { countryCode: 'gb-eng' }),
  },
  {
    value: 'zh',
    label: '中文',
    icon: React.createElement(CircleFlag, { countryCode: 'cn' }),
  },
  {
    value: 'ja',
    label: '日本語',
    icon: React.createElement(CircleFlag, { countryCode: 'jp' }),
  },
  {
    value: 'ko',
    label: '한국어',
    icon: React.createElement(CircleFlag, { countryCode: 'kr' }),
  },
] as const;

export function getText(language: Language, key: TranslationKey): string {
  return translations[language][key] || translations.en[key];
}
